export function createField(type, defaultValue, typeStr) {
    return { type, defaultValue, typeStr: typeStr };
}

export function getEntityTypes(entity) {
    let et = {};
    Object.keys(entity).forEach((key) => {
        et[key] = entity[key].type;
    });
    return et;
}

export function getEntityDefaults(entity) {
    let ed = {};
    Object.keys(entity).forEach((key) => {
        ed[key] = entity[key].defaultValue;
    });
    return ed;
}

export function mapEntity(baseEntity, entity) {
    return Object.keys(baseEntity).reduce((acc, key) => {
        const baseField = baseEntity[key];
        let value = entity[key];
        if (baseField.typeStr !== "bool" && !value) {
            value = baseField.defaultValue;
        }

        return { ...acc, [key]: value };
    }, {});
}
